import axios from "axios";

export async function getSpecialitiesByProvider() {
	try {
		const req = await axios.get(`${process.env.REACT_APP_DANSUAPI}/private/prestador_especialidades/`);
		return req.data
	} catch (error) {
		return {error}
	}
}